var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDoubleArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21.44,
  height: 16.73,
  viewBox: "0 0 21.44 16.73",
  preserveAspectRatio: "xMidYMid meet"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "doubleArrowRight")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2-2",
  "data-name": "Layer 1-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9,1V15.7a1,1,0,0,0,1,1,1,1,0,0,0,.63-.2L21,9.19a1,1,0,0,0,.27-1.39A.87.87,0,0,0,21,7.53L10.6.2A1,1,0,0,0,9.2.4,1,1,0,0,0,9,1",
  fill: "currentColor"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Layer_2-3",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2-3",
  "data-name": "Layer 1-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,1V15.7a1,1,0,0,0,1,1,1,1,0,0,0,.63-.2L12,9.19a1,1,0,0,0,.27-1.39A.87.87,0,0,0,12,7.53L1.6.2A1,1,0,0,0,.2.4,1,1,0,0,0,0,1",
  fill: "currentColor"
})))))));
export default SvgDoubleArrowRight;